// extracted by mini-css-extract-plugin
module.exports = {"textAreaContainer":"textAreaContainer--c1975","aiButtonPosition":"aiButtonPosition--44ea5","invalid":"invalid--351ab"};